import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row g-9 mb-8" }
const _hoisted_2 = { class: "col-md-3 fv-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Začiatok cyklu", -1)
const _hoisted_4 = { class: "col-md-3 fv-row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Koniec cyklu", -1)
const _hoisted_6 = { class: "col-md-3 fv-row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Zobraziť cyklus od", -1)
const _hoisted_8 = { class: "col-md-3 fv-row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Zobraziť cyklus do", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_npxForm = _resolveComponent("npxForm")!

  return (_openBlock(), _createBlock(_component_npxForm, {
    cardWrapper: "1",
    pageTitleNew: "Nový cyklus donášky",
    pageSubtitleNew: "Vyplňte povinné polia, pre pridanie nového cyklu donášky.",
    pageTitleEdit: "Upraviť cyklus donášky",
    pageSubtitleEdit: "Vyplňte povinné polia, pre úpravu cyklu donášky.",
    listPageRouter: "cycles",
    firestoreCollection: "cycles",
    fieldValues: _ctx.localFieldValues,
    fieldRules: _ctx.localFieldRules
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_form_item, { prop: "bgColor" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.localFieldValues.cycleStartDate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localFieldValues.cycleStartDate) = $event)),
                type: "date",
                format: "DD.MM.YYYY",
                placeholder: "Zvoľte začiatok cyklu"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_form_item, { prop: "bgColor" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.localFieldValues.cycleEndDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localFieldValues.cycleEndDate) = $event)),
                type: "date",
                format: "DD.MM.YYYY",
                placeholder: "Zvoľte koniec cyklu"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_form_item, { prop: "bgColor" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.localFieldValues.cycleShowDate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localFieldValues.cycleShowDate) = $event)),
                type: "datetime",
                format: "DD.MM.YYYY HH:mm",
                placeholder: "Zvoľte zobrazenie od"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_el_form_item, { prop: "bgColor" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                prop: "cycleHideDate",
                name: "cycleHideDate",
                modelValue: _ctx.localFieldValues.cycleHideDate,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localFieldValues.cycleHideDate) = $event)),
                type: "datetime",
                format: "DD.MM.YYYY HH:mm",
                placeholder: "Zvoľte zobrazenie do"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["fieldValues", "fieldRules"]))
}